import CustomInput from "../../../../../../Component/DigitalMarketing/CustomInput";
import { useGetHEListQuery } from "../../../../../../Service/PatientList";

const HandE = (props: any) => {
  const { formData, setFormData, handleChange, submit } = props;
  const { data: HEData } = useGetHEListQuery();

  const handEOptions = HEData?.data
    ? [{ label: HEData.data.name, value: HEData.data.id }]
    : [];

  const selectedHandE = handEOptions.find(
    (opt: any) => opt.value === Number(formData?.hematoxylinEosins)
  );

  return (
    <div>
      <div className="row mt-3">
        <span className="prescription-headline col-12 rounded mb-3">H&E</span>

        <div className="col-6">
          <CustomInput
            type="select"
            option={handEOptions}
            labelKey="label"
            valueKey="value"
            submit={submit}
            name="hematoxylinEosins"
            value={formData?.hematoxylinEosins || ""}
            onChange={handleChange}
            setFormData={setFormData}
          />
        </div>

        <div className="col-12 mt-3">
          <CustomInput
            type="textarea"
            name="hematoxylinEosinsText"
            value={selectedHandE?.label || ""}
            disabled={true}
          />
        </div>
      </div>
    </div>
  );
};

export default HandE;
